import {APIErrorDetail} from "@/shared/types";

export class APIError extends Error {
  code: string;
  message: string;
  details?: string | string[] | APIErrorDetail | APIErrorDetail[];

  constructor(code: string, message: string, details?: string | string[] | APIErrorDetail | APIErrorDetail[]) {
    super(message);
    this.name = "APIError";
    this.code = code;
    this.message = message;
    this.details = details;
  }
}

export function parseError(error: unknown): APIError {

  // Check instance of APIError
  if (error instanceof APIError) {
    return error;
  }

  // Check if error is a structured error object
  if (
    error &&
    typeof error === "object" &&
    "code" in error &&
    "message" in error &&
    typeof (error as Record<string, unknown>).code === "string" &&
    typeof (error as Record<string, unknown>).message === "string"
  ) {
    const err = error as Record<string, unknown>;
    return new APIError(
      err.code as string,
      err.message as string,
      err.details as APIErrorDetail | APIErrorDetail[] | string | string[] | undefined,
    );
  }

  // Fallback for unknown error shapes
  return new APIError("UNKNOWN", "An unknown error occurred", JSON.stringify(error));
}
